const Mutations = Object.freeze({
	SET_SELECTED_INVENTORY_FORM:
		'inventoryFormModule/inventoryFormHistory/SET_SELECTED_INVENTORY_FORM',
	SET_GRID_DATA: 'inventoryFormModule/inventoryFormHistory/SET_GRID_DATA',
	SET_TOTAL_COUNT: 'inventoryFormModule/inventoryFormHistory/SET_TOTAL_COUNT',
	SET_IRIS_USER_METADATA:
		'inventoryFormModule/inventoryFormHistory/SET_IRIS_USER_METADATA',
});

export const Actions = Object.freeze({
	LOAD_INVENTORY_FORM:
		'inventoryFormModule/inventoryFormHistory/LOAD_INVENTORY_FORM',
	LOAD_GRID_DATA: 'inventoryFormModule/inventoryFormHistory/LOAD_GRID_DATA',
	CLEAR: 'inventoryFormModule/inventoryFormHistory/CLEAR',
});

export const Getters = Object.freeze({
	GRID_DATA: 'inventoryFormModule/inventoryFormHistory/GRID_DATA',
	GRID_DATA_COUNT: 'inventoryFormModule/inventoryFormHistory/GRID_DATA_COUNT',
	GRID_COLUMNS: 'inventoryFormModule/inventoryFormHistory/GRID_COLUMNS',
	IRIS_USER_METADATA:
		'inventoryFormModule/inventoryFormHistory/IRIS_USER_METADATA',
});

import { GeneralActions } from '../../../../actions';
import dataService from '../../../../../services/data/inventoryFormService';
export default {
	state: {
		selectedInventoryform: null,
		data: [],
		totalCount: 0,
		irisUsersMetadata: [],
	},
	mutations: {
		[Mutations.SET_SELECTED_INVENTORY_FORM](state, item) {
			state.selectedInventoryform = item;
		},
		[Mutations.SET_GRID_DATA](state, items) {
			state.data = items;
		},
		[Mutations.SET_TOTAL_COUNT](state, value) {
			state.totalCount = value;
		},
		[Mutations.SET_IRIS_USER_METADATA](state, items) {
			state.irisUsersMetadata = items;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_GRID_DATA, []);
				commit(Mutations.SET_TOTAL_COUNT, 0);
				commit(Mutations.SET_IRIS_USER_METADATA);
				commit(Mutations.SET_SELECTED_INVENTORY_FORM, null);
				dispatch(GeneralActions.LOADING, false);
				resolve();
			});
		},
		[Actions.LOAD_INVENTORY_FORM]({ commit, dispatch }, itemId) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getById(itemId)
					.then((resp) => {
						commit(
							Mutations.SET_SELECTED_INVENTORY_FORM,
							resp.data
						);
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.LOADING, false);
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					});
			});
		},
		[Actions.LOAD_GRID_DATA]({ commit, dispatch }, payload) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.loadHistoryData(payload)
					.then((resp) => {
						commit(Mutations.SET_GRID_DATA, resp.data.Data);
						commit(Mutations.SET_TOTAL_COUNT, resp.data.Count);
						commit(
							Mutations.SET_IRIS_USER_METADATA,
							resp.data.IrisUsers
						);
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.LOADING, false);
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					});
			});
		},
	},
	getters: {
		[Getters.GRID_DATA]: (state) => {
			if (!state.data) return [];
			if (state.data.length < 0) return [];
			return JSON.parse(JSON.stringify(state.data));
		},
		[Getters.GRID_DATA_COUNT]: (state) => {
			if (!state) return 0;
			if (!state.totalCount) return 0;
			return state.totalCount;
		},
		[Getters.GRID_COLUMNS]: (state) => {
			if (!state.selectedInventoryform) return [];
			if (!state.selectedInventoryform.FormFields) return [];
			if (state.selectedInventoryform.FormFields.length <= 0) return [];
			let formFields = state.selectedInventoryform.FormFields.filter(
				(x) => x.HiddenBehaviour === 0
			).sort((a, b) => a.Order - b.Order);
			let gvf = [];
			formFields.forEach((f) => {
				gvf = [...gvf, ...f.GridViewFields];
			});
			return JSON.parse(JSON.stringify(gvf));
		},
		[Getters.IRIS_USER_METADATA]: (state) => {
			if (!state.irisUsersMetadata) return [];
			if (state.irisUsersMetadata.length <= 0) return [];
			return JSON.parse(JSON.stringify(state.irisUsersMetadata));
		},
	},
};
